module.exports = __webpack_public_path__ + "img/revocation.f1d6f49d.svg";